import { connectorsByIdentifier } from "./index";
import { matchesSearchText } from "./matchesSearchText";
import { matchesUrlPattern } from "./matchesUrlPattern";

// Shared by the picker (which apps to offer) and the server auto-connect (which
// app to attach unattended) so the two never disagree on what "matches". Every
// provided criterion must match: `search` states what kind of connector the
// request is for, `targetUrl` where it lives — a URL match alone must not
// satisfy a request that also named a different kind (e.g. an MCP server
// hosted on a vendor's domain). Search also matches the app's definition name
// and tagline, so instances match by kind regardless of how they were named.
export function appMatchesConnectRequest(
  app: { urlPattern: string; identifier: string; name: string },
  request: { targetUrl?: string | null; search?: string | null }
): boolean {
  if (!request.targetUrl && !request.search) return false;
  if (
    request.targetUrl &&
    !matchesUrlPattern(app.urlPattern, request.targetUrl)
  ) {
    return false;
  }
  if (request.search) {
    if (request.targetUrl) {
      const target = new URL(
        request.targetUrl.includes("://")
          ? request.targetUrl
          : `https://${request.targetUrl}`
      );
      if (request.search.trim().toLowerCase() === target.hostname) return true;
    }
    const definition = connectorsByIdentifier[app.identifier];
    const matches = matchesSearchText(
      [
        app.identifier,
        app.name,
        definition?.name,
        definition?.tagLine,
        definition?.keywords,
      ],
      request.search
    );
    if (!matches) return false;
  }
  return true;
}
